import {useStompClient, useSubscription} from "react-stomp-hooks";
import {useState} from "react";
import {StompHeaders} from "@stomp/stompjs";
import {useKeycloak} from "@react-keycloak/web";
import {Button, Col, List, message, Row, Tooltip} from "antd";
import {UploadStatus} from "../../../enums/UploadStatus";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {CameraTwoTone, InfoCircleOutlined} from "@ant-design/icons";
import './style.scss'
import documentService from "../../../service/documentService";


export default function TakePhotoButton({
                                            username,
                                            documentTypeId,
                                            imageType,
                                            jobNumber,
                                            buttonName,
                                            btnQuestion,
                                            participantConnectingStatus,
                                            onTakePictureSuccess,
                                            onTakingPictureAddLoader,
                                            disableCaptureBtn
                                        }: {
    username: string,
    documentTypeId: number,
    imageType: string,
    jobNumber: number,
    buttonName: string,
    btnQuestion: string,
    participantConnectingStatus: ParticipantStatus,
    onTakePictureSuccess: () => void
    onTakingPictureAddLoader: () => void,
    disableCaptureBtn: boolean
}) {

    const {keycloak} = useKeycloak();
    const onTakePicture = () => {
        onTakePictureSuccess()
    }
    const onTakingPicture = () => {
        onTakingPictureAddLoader()
    }
    return (<SubscribingComponent username={username} documentTypeId={documentTypeId} imageType={imageType}
                                  buttonName={buttonName}
                                  jobNumber={jobNumber}
                                  participantConnectingStatus={participantConnectingStatus} btnQuestion={btnQuestion}
                                  onTakePicture={onTakePicture}
                                  onTakingPicture={onTakingPicture}
                                  disableCaptureBtn={disableCaptureBtn}

    />)
}

const SubscribingComponent: React.FC<{
    username: string,
    documentTypeId: number,
    jobNumber: number,
    imageType: string,
    buttonName: string,
    btnQuestion: string,
    participantConnectingStatus: string,
    onTakePicture: () => void,
    onTakingPicture: () => void,
    disableCaptureBtn: boolean,
}> = ({
          username, documentTypeId, jobNumber, imageType, buttonName, btnQuestion, participantConnectingStatus,
          onTakePicture, onTakingPicture, disableCaptureBtn
      }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState<boolean>(false);
    const {keycloak} = useKeycloak();
    let stompHeaders: StompHeaders = {
        "accessToken": keycloak.token ? keycloak.token : "",
        "username": username
    }
    /* Temporary solution start*/
    const [timeoutId, setTimeoutId] = useState(null);
    /*end*/

    const stompClient = useStompClient();
    const takePicture = (e: any) => {
        if (participantConnectingStatus == ParticipantStatus.PARTICIPANT_CONNECTED) {
            setLoading(true);
            //following is used to add disabled to other capture  btns
            onTakingPicture();

            /* Temporary solution start*/
            const newTimeoutId = setTimeout(() => {
                console.log("============ Calling Timeout ===============")
                setLoading(false);
                messageApi.open({
                    key: imageType,
                    type: 'error',
                    content: 'Please try again.',
                    duration: 3,
                });
                documentService.documentCaptureFailedFixing(jobNumber, imageType).then(res => {
                    console.log(res.data)
                })
                onTakePicture()
            }, 30000);

            setTimeoutId(newTimeoutId);
            /*end*/
            console.log("=========== Sending request =================")
            stompClient?.publish({
                destination: `/video/app/send-image-upload-request`,
                body: JSON.stringify({
                    "documentTypeId": documentTypeId,
                    "imageType": imageType,
                    "uploadStatus": UploadStatus.UPLOADING,
                    "username": username
                })
            });
        } else {
            messageApi.open({
                key: imageType,
                type: 'warning',
                content: `Participant not connected`,
                duration: 3,
            });
        }
    }


    useSubscription("/user/topic/local-check-image-upload-response", (message) => {
        let res: any = JSON.parse(message.body);
        /* Temporary solution start*/
        console.log("========= Response Received ===========", res)
        stompClient?.publish({
            destination: `/video/app/acknowledge`,
            body: message.headers.messageId
        });
        console.log(`local-check-image-upload-response Acknowledgment sent for message: ${message.headers.messageId}`);
        clearTimeout(timeoutId);
        /*end*/
        if (res.content, res.errorMessage) {
            setLoading(false);
            messageApi.open({
                key: imageType,
                type: 'error',
                content: `${buttonName} cannot be uploaded`,
                duration: 3,
            });
        } else {
            if (documentTypeId == res.documentTypeId) {
                if (res.uploadStatus == UploadStatus.UPLOADED) {
                    setLoading(false);
                    messageApi.open({
                        key: imageType,
                        type: 'success',
                        content: `${buttonName} successfully uploaded`,
                        duration: 3,
                    });
                    onTakePicture()
                } else {
                    setLoading(false);
                    messageApi.open({
                        key: imageType,
                        type: 'error',
                        content: `${buttonName} cannot be uploaded`,
                        duration: 3,
                    });
                    onTakePicture()
                }

            }
        }
    }, stompHeaders);


    const dataList = [
        {id: 1, title: 'Item 1'},
        // { id: 2, title: 'Item 2' },
        // Add more items as needed
    ];

    const renderItem = (item: { title: any; }) => (
        <>
            {/*<List.Item >*/}

            <div className="container_a">
                <Button style={{padding: 8}} className="button_a" size="small" htmlType="button" loading={loading}
                        disabled={disableCaptureBtn}
                        onClick={takePicture}>
                    <div className="capture-btn-body">
                        <CameraTwoTone className={'camara-icon'} twoToneColor="#ff7300"/>
                        {buttonName}
                    </div>
                </Button>

                <Tooltip title={btnQuestion}>
                    <InfoCircleOutlined className='capture-info-icon'/>
                </Tooltip>
            </div>
        </>
    );

    return <>
        {contextHolder}
        <Row gutter={[16, 16]} className='capturing_list'>
            <Col span={24}>
                <List
                    dataSource={dataList}
                    renderItem={renderItem}
                />
            </Col>
        </Row>

    </>
}
